import { render, staticRenderFns } from "./ObtaclesConfig.vue?vue&type=template&id=5b034948&scoped=true&"
import script from "./ObtaclesConfig.vue?vue&type=script&lang=js&"
export * from "./ObtaclesConfig.vue?vue&type=script&lang=js&"
import style0 from "./ObtaclesConfig.vue?vue&type=style&index=0&id=5b034948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b034948",
  null
  
)

export default component.exports